import styled from 'styled-components';

import { device } from '../../Config/device';

import Button from '../Buttons/Button';

export const Container = styled.div`
    margin-right: 24px;
`;

export const MainContentContainer = styled.div`
    ${
        props => !props.NoPadding && `
        @media ${device.maxwidth.mobile_small} {
            padding: var(--spacer-size-extra-small);
        }
        
        @media ${device.minwidth.mobile} {
            padding: var(--spacer-size-small-1);
        }
    `}
`;

export const PageContainer = styled.div`
    background-color: ${props => props.NoBackground ? 'inherit' : 'var(--white)'};
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    min-height: 50px;
`;

export const SplitButtonContainer = styled.div`
    align-items: center;
    background-color: ${props => props.Disabled ? 'var(--gray)' : props.ButtonName === 'One' ? 'var(--blue-astronaut)' : 'var(--blue-abel)'};
    color: ${props => props.Disabled ? 'var(--black)' : 'var(--white)'};
    font-family: var(--font-family-semibold);
    font-size: var(--font-size-medium-3);
    display: flex;
    flex: 1;
    justify-content: center;
    padding: 10px 30px;

    @media(hover:hover) {
        :hover {
            background-color: ${props => props.Disabled ? 'var(--dark-gray)' : props.ButtonName === 'One' ? 'var(--blue-astronaut-hover)' : 'var(--abel-blue-hover)'};
            cursor: ${props => props.Disabled ? 'not-allowed' : 'pointer'};
        }
    }
`;

export const SplitButtonsContainer = styled.div`
    align-items: stretch;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    overflow: hidden;
`;

export const StyledSubmitButton = styled(Button)`
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
`;